import { render, staticRenderFns } from "./AutoCheckCertificateFranchises.vue?vue&type=template&id=238fac49&"
import script from "./AutoCheckCertificateFranchises.vue?vue&type=script&lang=js&"
export * from "./AutoCheckCertificateFranchises.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports